module.exports = __webpack_public_path__ + "static/media/cross-lg.fc3c3492.svg";